module.exports = __webpack_public_path__ + "static/img/target_a2.72fb1bbe.png";